"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/row/style/css");

var _row = _interopRequireDefault(require("antd/es/row"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _avatar = require("../../redux/avatar/avatar.types");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class Avatars extends _react.Component {
  async componentDidMount() {
    this.props.getAvatars();
  }

  render() {
    const {
      avatars
    } = this.props;
    const avatarCols = [];

    if (avatars) {
      avatars.forEach(avatar => {
        avatarCols.push( /*#__PURE__*/_react.default.createElement(_col.default, {
          id: avatar.id.toString(),
          key: avatar.id,
          span: 4
        }, /*#__PURE__*/_react.default.createElement(_card.default, {
          style: {
            height: 120,
            textAlign: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: avatar.avatar,
          style: {
            width: 80,
            alignSelf: 'center'
          }
        }))));
      });
    }

    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_row.default, null, avatarCols));
  }

}

const mapStateToProps = state => {
  const avatars = selectors.getAvatars(state);
  return {
    avatars
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAvatars: () => dispatch(_avatar.getAvatarsAsync.request())
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Avatars);

exports.default = _default;